import React from "react";

const PageSection = ({ data, compactTop = false }) => {
  const getSectionPadding = (index) => {
    if (!compactTop) {
      return "py-12 sm:py-16";
    }
    return index === 0 ? "pt-6 sm:pt-8 pb-10 sm:pb-12" : "py-10 sm:py-12";
  };

  return (
    <>
      {data.page.map((page, pageIndex) => (
        <section
          key={page.title || pageIndex}
          className={`bg-ofWhite ${getSectionPadding(
            pageIndex
          )} px-4 sm:px-6 lg:px-8`}
          id={page.title ? page.title.replace(/\s+/g, "-").toLowerCase() : ""}
        >
          <div className="max-w-7xl mx-auto space-y-10">
            {page.title && (
              <div className="text-center md:text-left">
                <h2 className="text-2xl md:text-3xl font-semibold text-black">
                  {page.title}
                </h2>
                <div className="absolute bottom-0 left-1 border-box mt-3 h-[2px]" />
              </div>
            )}
            {page.sections.map((section, index) => {
              const hasImage = Boolean(section.image);
              const hasLogoGrid = Array.isArray(section.images);
              return (
                <article
                  key={section.id || `${pageIndex}-${index}`}
                  className="bg-white3 rounded-[32px] border border-white2 shadow-[0_20px_60px_rgba(7,17,36,0.08)] overflow-hidden"
                >
                  <div
                    className={`grid gap-8 ${hasImage ? "md:grid-cols-2" : ""}`}
                  >
                    <div className="p-6 sm:p-10 space-y-6">
                      {section.heading && (
                        <div className="space-y-2">
                          <h3 className="text-2xl font-semibold text-black">
                            {section.heading}
                          </h3>
                          <div className="absolute bottom-0 left-1 border-box mt-3 h-[2px]" />
                        </div>
                      )}
                      {section.content && (
                        <div
                          className="text-sm md:text-base leading-relaxed text-black/70 space-y-4"
                          dangerouslySetInnerHTML={{
                            __html: section.content,
                          }}
                        />
                      )}
                      {section.list && (
                        <ul className="list-disc list-inside space-y-2 text-black/70">
                          {section.list.map((item, i) => (
                            <li key={i}>
                              {item.text || item}
                              {item.subList && item.subList.length > 0 && (
                                <ul className="list-disc list-inside ml-5 mt-2 space-y-1 text-black/60">
                                  {item.subList.map((sub, j) => (
                                    <li key={j}>{sub}</li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                      {section.content2 && (
                        <div
                          className="text-sm md:text-base leading-relaxed text-black/70 space-y-4"
                          dangerouslySetInnerHTML={{
                            __html: section.content2,
                          }}
                        />
                      )}
                    </div>
                    {hasImage && (
                      <div className="relative min-h-[260px]">
                        <img
                          src={section.image}
                          alt={section.heading || page.title || "Network"}
                          className="absolute inset-0 h-full w-full object-contain p-6"
                        />
                      </div>
                    )}
                  </div>
                  {hasLogoGrid && (
                    <div className="px-6 sm:px-10 pb-10">
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
                        {section.images.map((partner, logoIndex) => (
                          <div
                            key={logoIndex}
                            className="rounded-2xl border border-white2 bg-ofWhite flex items-center justify-center py-4 px-3"
                          >
                            <img
                              src={partner.image}
                              alt={partner.name || "Partner logo"}
                              className="max-h-12 w-auto object-contain"
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        </section>
      ))}
    </>
  );
};

export default PageSection;
